import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./uploadResultFile.css";

export default function UploadResultFile() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [classes,  setClasses]  = useState([]);
  const [sections, setSections] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [exams,    setExams]    = useState([]);

  const [classId,   setClassId]   = useState("");
  const [sectionId, setSectionId] = useState("");
  const [subject,   setSubject]   = useState("");
  const [examId,    setExamId]    = useState("");
  const [file,      setFile]      = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => { loadClasses(); loadExams(); }, []);

  const loadClasses = async () => {
    const res = await API.get("/school-admin/classes/", {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setClasses(res.data.classes || []);
  };

  const loadExams = async () => {
    const res = await API.get("/school-admin/exams/", {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setExams(res.data.exams || []);
  };

  const loadSections = async (id) => {
    if (!id) return setSections([]);
    const res = await API.get(`/school-admin/sections/${id}/`, {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setSections(res.data.sections || []);
  };

  const loadSubjects = async (cid, sid) => {
    const res = await API.get("/school-admin/subjects/by-class-section/", {
      headers: { "X-SCHOOL-ID": school.school.id },
      params: { class_id: cid, section_id: sid },
    });
    setSubjects(res.data.subjects || []);
  };

  useEffect(() => {
    if (classId) { loadSections(classId); loadSubjects(classId, sectionId); }
  }, [classId]);

  useEffect(() => {
    if (classId) loadSubjects(classId, sectionId);
  }, [sectionId]);

  const submitFile = async (e) => {
    e.preventDefault();
    if (!file) return alert("Please select a file");
    const formData = new FormData();
    formData.append("exam_id",    examId);
    formData.append("class_id",   classId);
    formData.append("section_id", sectionId);
    formData.append("subject",    subject);
    formData.append("file",       file);
    try {
      setUploading(true);
      await API.post("/school-admin/results/upload-file/", formData, {
        headers: {
          "X-SCHOOL-ID": school.school.id,
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Result file uploaded successfully!");
      setFile(null);
      e.target.reset();
    } catch {
      alert("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="urf-page">

      {/* ══ HERO ══ */}
      <div className="urf-hero">
        <div className="urf-hero-left">
          <div className="urf-hero-icon">📁</div>
          <div>
            <h2 className="urf-hero-title">Upload Result File</h2>
            <p className="urf-hero-sub">Upload PDF, Excel, or Image result files for any exam</p>
          </div>
        </div>
      </div>

      {/* ══ FORM ══ */}
      <form onSubmit={submitFile}>

        <div className="urf-card">
          <p className="urf-card-title">Exam & Class Details</p>

          <div className="urf-grid-2">
            <div className="urf-field">
              <label>Exam</label>
              <select value={examId} onChange={e => setExamId(e.target.value)} required>
                <option value="">— Select Exam —</option>
                {exams.map(ex => (
                  <option key={ex.id} value={ex.id}>{ex.name}</option>
                ))}
              </select>
            </div>

            <div className="urf-field">
              <label>Class</label>
              <select
                value={classId}
                onChange={e => { setClassId(e.target.value); setSectionId(""); }}
                required
              >
                <option value="">— Select Class —</option>
                {classes.map(c => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>

            <div className="urf-field">
              <label>Section <span style={{ fontWeight:400, textTransform:"none" }}>(optional)</span></label>
              <select value={sectionId} onChange={e => setSectionId(e.target.value)}>
                <option value="">All Sections</option>
                {sections.map(s => (
                  <option key={s.id} value={s.id}>{s.name}</option>
                ))}
              </select>
            </div>

            <div className="urf-field">
              <label>Subject</label>
              <select value={subject} onChange={e => setSubject(e.target.value)} required>
                <option value="">— Select Subject —</option>
                {subjects.map(s => (
                  <option key={s.id} value={s.name}>{s.name}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="urf-card">
          <p className="urf-card-title">Result File</p>

          <div className="urf-field urf-grid-1">
            <label>Upload File <span style={{ fontWeight:400, textTransform:"none" }}>(PDF / Excel / Image)</span></label>
            <div className="urf-file-zone" onClick={() => document.getElementById("resultFile").click()}>
              <div className="urf-file-icon">📎</div>
              <p className="urf-file-hint">Click to browse file</p>
              <p className="urf-file-types">PDF · Excel · JPG · PNG</p>
              {file && <p className="urf-file-chosen">✓ {file.name}</p>}
              <input
                id="resultFile"
                type="file"
                hidden
                onChange={e => setFile(e.target.files[0])}
              />
            </div>
          </div>

          <button className="urf-btn-submit" type="submit" disabled={uploading}>
            {uploading
              ? <><div className="urf-spinner"></div> Uploading…</>
              : "⬆ Upload Result File"
            }
          </button>
        </div>

      </form>
    </div>
  );
}
